module.exports = __webpack_public_path__ + "static/3-394cc50e3e2c3e74ce8771d566c802c5.jpg";